
    <h2 mat-dialog-title style="color: #424242; font-family: Roboto; margin: 0; padding: 16px 24px; background: white;">
      {{ data.job ? data.job.subdivision_name + ' - ' + data.job.lot : 'General Timecard Note' }}
    </h2>
    <div mat-dialog-content style="padding: 0 24px; background: white;">
      <div *ngIf="notes.length > 0" style="margin-bottom: 15px; max-height: 200px; overflow-y: auto;">
        <div *ngFor="let n of notes" style="padding: 8px; border-bottom: 1px solid #eee; display: flex; justify-content: space-between; align-items: flex-start;">
          <span style="color: #424242; flex: 1; word-break: break-word; white-space: pre-wrap;">{{ n.note }}</span>
          <div style="display: flex; align-items: center; margin-left: 10px; white-space: nowrap;">
            <span *ngIf="n.created_by" style="color: #8a8a8a; font-size: 12px; margin-right: 8px;">{{ n.created_by }}</span>
            <span style="color: #8a8a8a; font-size: 12px; margin-right: 8px;">{{ n.created_at?.substring(0,10) }}</span>
            <i class="fa fa-trash" style="color: #910000; cursor: pointer;" (click)="deleteNote(n.id)" title="Delete note"></i>
          </div>
        </div>
      </div>
      <div *ngIf="notes.length === 0 && !isLoading" style="color: #8a8a8a; margin-bottom: 10px; font-style: italic;">
        No notes yet.
      </div>
      <div style="margin-bottom: 15px;">
        <textarea [(ngModel)]="noteText"
                  [disabled]="isLoading"
                  placeholder="Enter a note..."
                  rows="3"
                  style="width: 100%; padding: 8px; border: 1px solid #ddd; border-radius: 4px; resize: vertical; font-family: Roboto; font-size: 14px; box-sizing: border-box;">
        </textarea>
      </div>
    </div>
    <div mat-dialog-actions style="justify-content: flex-end; padding: 8px 24px; background: white;">
      <button mat-button (click)="dialogRef.close()" style="color: #666;">Close</button>
      <button mat-raised-button (click)="saveNote()"
              [disabled]="!noteText?.trim() || isLoading"
              style="background-color: #477333; color: white; margin-left: 8px;">
        Save Note
      </button>
    </div>
  